"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollablePane = void 0;
var ScrollablePane_styles_1 = require("./ScrollablePane.styles");
var ScrollablePane_base_1 = require("./ScrollablePane.base");
var Utilities_1 = require("../../Utilities");
exports.ScrollablePane = Utilities_1.styled(ScrollablePane_base_1.ScrollablePaneBase, ScrollablePane_styles_1.getStyles, undefined, { scope: 'ScrollablePane' });
//# sourceMappingURL=ScrollablePane.js.map